(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__shakuntalaStockNote) return;
    window.__shakuntalaStockNote = true;

    const showNote = (wrapper) => {
      const note = wrapper && wrapper.querySelector('.quantity-stock-note');
      if (!note) return;
      note.hidden = false;
      clearTimeout(note._hideTimer);
      note._hideTimer = setTimeout(() => {
        note.hidden = true;
      }, 4000);
    };

    // Customer taps "+" when already at the stock limit
    document.addEventListener('click', (event) => {
      const catcher = event.target instanceof Element && event.target.closest('.quantity-stock-catcher');
      if (catcher) showNote(catcher.closest('.quantity-selector-wrapper'));
    });

    // Customer types a number higher than what is in stock
    document.addEventListener('input', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.dataset.stockMax) return;
      if ((parseInt(input.value, 10) || 0) > parseInt(input.dataset.stockMax, 10)) {
        showNote(input.closest('.quantity-selector-wrapper'));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
